import { CountryCode } from 'modules/company/types/company.type';
import { extractSiren } from 'modules/company/utils/extractSiren';

export const generateVatNumber = ({
  registrationNumber,
  countryCode,
}: {
  registrationNumber: string;
  countryCode: CountryCode;
}): string | undefined => {
  switch (countryCode) {
    case 'FR': {
      const siren = extractSiren(registrationNumber);
      const sirenNum = Number(siren);

      const key = (12 + 3 * (sirenNum % 97)) % 97;
      const formattedKey = String(key).padStart(2, '0');

      return `FR${formattedKey}${siren}`;
    }
    case 'BE': {
      return `BE${registrationNumber}`;
    }
    default:
      return undefined;
  }
};
